import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { SegmentoEducacaoComponent } from './segmento-educacao.component';
import { CabecalhoEsquerdaModule } from '../../components/cabecalho/cabecalho-esquerda/cabecalho-esquerda.module';
import { SolucoesModule } from '../../components/solucoes/solucoes.module';
import { ExemplosModule } from '../../components/exemplos/exemplos.module';

@NgModule({
  declarations: [
    SegmentoEducacaoComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    CabecalhoEsquerdaModule,
    SolucoesModule,
    ExemplosModule
  ],
  exports: [
    SegmentoEducacaoComponent
  ]
})

export class SegmentoEducacaoModule { }
